module.exports = __webpack_public_path__ + "static/media/4.ad71085a.png";